import { cn } from '../../utils/cn'
import Button from '../Buttons/Button'

interface Props {
  text: string
  /**
   * `dismissible` shows a close icon on the right, `action` shows a button.
   * A banner with neither is just an informational bar.
   */
  variant?: 'info' | 'dismissible' | 'action'
  actionText?: string
  onAction?: () => void
  onDismiss?: () => void
  isActionDisabled?: boolean
  className?: string
}

const Banner = ({
  text,
  variant = 'info',
  actionText,
  onAction,
  onDismiss,
  isActionDisabled = false,
  className,
}: Props) => {
  return (
    <div
      role='status'
      className={cn(
        'bg-totalBg w-full flex items-center justify-between gap-5 px-5 md:px-7 lg:px-9 py-4 flex-wrap',
        className,
      )}
    >
      <p className='text-primaryBlue font-semibold text-base flex-1 min-w-[200px]'>
        {text}
      </p>

      {variant === 'action' && actionText && (
        <Button
          type='button'
          text={actionText}
          width='w-max'
          disabled={isActionDisabled}
          onClickHandler={onAction}
        />
      )}

      {variant === 'dismissible' && (
        <button
          type='button'
          onClick={onDismiss}
          aria-label='close'
          className='text-primaryBlue hover:opacity-70 transition-opacity shrink-0'
        >
          <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M5 5L15 15M15 5L5 15'
              stroke='currentColor'
              strokeWidth='1.8'
              strokeLinecap='round'
            />
          </svg>
        </button>
      )}
    </div>
  )
}

export default Banner
